import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { Spinner } from 'ui';

import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';

const TAB_RECORD = 'record';
const TAB_RESPONSES = 'responses';

const RepeatablePracticeTabs = ({
  selectedTab,
  setSelectedTab,
  userResponses,
  isTabDisabled,
  isRecordingQuestion,
  previewing,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const isTabSelected = tabName => tabName === selectedTab;
  const tabs = [TAB_RECORD, TAB_RESPONSES];

  useEffect(() => {
    if (!userResponses.length) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [userResponses]);

  const recordTabText = isRecordingQuestion
    ? t('practice.repeatability.record')
    : t('practice.repeatability.write');
  return (
    <div className="d-f fd-r border-bottom border-gray-light ml-32 mr-32 mb-16">
      {tabs.map(tab => (
        <button
          key={`practice-repeatability-tab-${tab}`}
          type="button"
          onClick={() => setSelectedTab(tab)}
          onMouseDown={e => {
            // Prevents mouse click focus ring
            e.preventDefault();
          }}
          className={classNames(
            'RepeatablePracticeTabs u-resetBtn pr-8 pl-4 mr-16 pb-8',
            {
              'RepeatablePracticeTabs--selected': isTabSelected(tab),
              'RepeatablePracticeTabs--disabled':
                isTabDisabled && tab === TAB_RESPONSES,
              'mb-4': !isTabSelected(tab),
            },
          )}
        >
          <Text
            className={
              (classNames({
                'opacity-50': !isTabSelected(tab),
              }),
              'd-f')
            }
            variant={
              isTabSelected(tab)
                ? TEXT_VARIANTS.SUBHEADER_BOLD
                : TEXT_VARIANTS.SUBHEADER
            }
          >
            {tab === TAB_RECORD
              ? recordTabText
              : t('practice.repeatability.my_responses')}
            {tab === TAB_RESPONSES && (!isLoading || previewing) && (
              <div className="QuestionElement--numberIcon">
                <div className="QuestionElement--numberColor">
                  {userResponses.length}
                </div>
              </div>
            )}
            {isLoading && !isTabDisabled && tab === TAB_RESPONSES && (
              <div className="d-f jc-c ai-c ">
                <Spinner />
              </div>
            )}
          </Text>
        </button>
      ))}
    </div>
  );
};

export default RepeatablePracticeTabs;
